import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-lg-9 mx-auto" }
const _hoisted_2 = { class: "text-center mt-5 mt-md-0 mb-4" }
const _hoisted_3 = { class: "skin-page-heading" }
const _hoisted_4 = { class: "container-fluid px-0 mt-0" }

import { ref, computed } from "vue";
import { useStore } from "vuex";
import ManagementChoices from "./secure/ManagementChoices.vue";
import Product from "./secure/Product.vue";
import DIY from "./secure/DIY.vue";
import Advice from "./secure/Advice.vue";

type OptionType = 'DIY' | 'Guidance' | 'Advice';


export default /*@__PURE__*/_defineComponent({
  __name: 'Options',
  setup(__props) {

const store = useStore();

const selectedOption = ref<null|OptionType>(null);

const isInactiveUser = computed<boolean>(() => {
    return !(store.state.retiree?.isApplicant ?? false);
});

const title = computed<string>(() => {
    return isInactiveUser.value ? "Options to put your plan in place" : "Putting your plan in place with guidance";
})

function onDetailRequested(option: OptionType) {
  selectedOption.value = option;
}

function onBackClicked() {
    selectedOption.value = null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (isInactiveUser.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (selectedOption.value == null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mx-5" }, " Our planning tools support you with actuarial calculations to build a retirement plan and help you monitor this over time. This plan aims to show how your income goals could be met over your expected lifetime if things turn out as expected. ", -1)),
                  _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mx-5" }, " We cannot provide advice on which products are suitable for you specifically, or how you should invest your money. We can highlight a number of alternative high level options and show more details if you decide to click on these. ", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mx-5 mb-4 fw-bold" }, " If you want a specific recommendation on a suitable provider you must take the advice option below. ", -1))
                ], 64))
              : _createCommentVNode("", true),
            (selectedOption.value == null)
              ? (_openBlock(), _createBlock(ManagementChoices, {
                  key: 1,
                  onDetailRequested: onDetailRequested
                }))
              : _createCommentVNode("", true),
            (selectedOption.value == 'DIY')
              ? (_openBlock(), _createBlock(DIY, {
                  key: 2,
                  onBack: onBackClicked
                }))
              : _createCommentVNode("", true),
            (selectedOption.value == 'Guidance')
              ? (_openBlock(), _createBlock(Product, {
                  key: 3,
                  onBack: onBackClicked
                }))
              : _createCommentVNode("", true),
            (selectedOption.value == 'Advice')
              ? (_openBlock(), _createBlock(Advice, {
                  key: 4,
                  onBack: onBackClicked
                }))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "Thank you for applying for the Pathlines pension product.", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "Your application is now being processed. You can come back here to check on progress, or contact Pathlines directly.", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, "We will know when your Pathlines account is active. When that happens you will see further content here.", -1))
          ], 64))
    ])
  ]))
}
}

})